import { render, staticRenderFns } from "./SubOffice.vue?vue&type=template&id=d4c21b84&scoped=true&"
import script from "./SubOffice.vue?vue&type=script&lang=js&"
export * from "./SubOffice.vue?vue&type=script&lang=js&"
import style0 from "./SubOffice.vue?vue&type=style&index=0&id=d4c21b84&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c21b84",
  null
  
)

export default component.exports